<div class="modal-header" style="border-bottom: 1px solid #e2e2e2">
    <h4>Details of {{userModalDetails.firstName.trim()}}, {{userModalDetails.lastName.trim()}}</h4>
    <i class="d-flex justify-content-end icon-ic_delete px-2" (click)="modalRef.hide()" style="cursor: pointer;margin-top: 8px;"></i>
</div>
<div class="modal-body">
    <div class="row pt-2">
        <div class="col-md-5 col-lg-5 col-xl-5">
          <strong>Name:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
          <label>{{userModalDetails.firstName.trim()}}, {{userModalDetails.lastName.trim()}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
          <strong>Email:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
          <label>{{userModalDetails.emailId}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Role:</strong>
          </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{userModalDetails.appRoleName}}</label>
        </div>     
        <!-- <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>City:</strong>
          </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{userModalDetails.cityName}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Work Location:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{userModalDetails.officeName}}</label>
        </div> -->
        <div class="col-md-5 col-lg-5 col-xl-5">
  <strong>City:</strong>
</div>
<div class="col-md-7 col-lg-7 col-xl-7">
  <label>{{ cityNamesDisplay }}</label>
</div>
<div class="col-md-5 col-lg-5 col-xl-5">
  <strong>Work Location:</strong>
</div>
<div class="col-md-7 col-lg-7 col-xl-7">
  <label>{{ officeNamesDisplay }}</label>
</div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Status:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <span class="circle" [ngClass]="{'bg-red': !userModalDetails.isActive,'bg-green': userModalDetails.isActive}"></span>
            <span class="showellipsis">{{userModalDetails.isActive ? 'Active' : 'Inactive'}}</span>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Date Added:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{userModalDetails.dateAdded | date:'d/MMM/y, h:mm a'}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Added By:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{userModalDetails.addedBy}}</label>
        </div>
        <div class="col-md-5 col-lg-5 col-xl-5">
            <strong>Practice:</strong>
        </div>
        <div class="col-md-7 col-lg-7 col-xl-7">
            <label>{{ practiceNamesDisplay }}</label>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="modalRef.hide()" type="button" class="button">
        Cancel
    </button>
</div>